import React from "react";
import "./ECLLoader.css";
import { ECLThemeImage } from "../../index";
import { staticURL } from "../../../utilities/requests";
import { translate } from "../../../utilities/Translate";

//Takes a single optional prop, message, which will be conditionally rendered under the loading indicator
export default function ECLLoader(props) {
   //Error loader image
   if (props.message) {
      return (
         <div className="ecl-loader">
            <ECLThemeImage
               fontAwesome="triangle-exclamation"
               alt="Error icon"
            />
            <p data-testid="error-message">
               {translate("Error: ") + props.message}
            </p>
         </div>
      );
   }
   return (
      <div className="ecl-loader">
         <img
            data-testid="spinnable-image"
            className="spinnable-image"
            src={staticURL + "icons/Eclipse/SourceOne-Avatar-Loader.svg"}
         />
         <p data-testid="loading-message">{translate("Loading...")}</p>
      </div>
   );
}
